import { type FunctionComponent } from 'react';
import { Avatar } from '@fluentui/react-components';
import { observer } from 'owa-mobx-react';
import { getUserConfiguration } from 'owa-session-store';

const MeControlPlaceholder: FunctionComponent = observer(function MeControlPlaceholder() {
    const sessionSettings = getUserConfiguration();
    const userDisplayName = sessionSettings?.SessionSettings?.UserDisplayName || '';

    return <Avatar name={userDisplayName} size={32} />;
}, 'MeControlPlaceholder');

export default MeControlPlaceholder;
